// LLM generated - Model Claude 4 Sonnet
import { format } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

import { useStyles } from './BonusCountdown.styles';
import { useBonusCountdown } from './useBonusCountdown';

interface BonusCountdownProps {
  expirationDate?: Date;
}

export function BonusCountdown({ expirationDate }: BonusCountdownProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('promotions');

  // Always call hook with a valid date (use current date as fallback to satisfy React rules)
  const countdownResult = useBonusCountdown(expirationDate || new Date());

  // Determine actual countdown values based on whether we have an expiration date
  const timeLeft = expirationDate ? countdownResult.timeLeft : '';
  const shouldShowCountdown = expirationDate ? countdownResult.shouldShowCountdown : false;
  const hasDeadlinePassed = expirationDate ? countdownResult.hasDeadlinePassed : false;

  // Don't render if no expiration date provided or if deadline has passed
  if (!expirationDate || hasDeadlinePassed) {
    return null;
  }

  // Show date when not counting down, countdown when within 48 hours
  const displayText = shouldShowCountdown ? timeLeft : format(expirationDate, 'M/d/yy');
  const timeClassName = shouldShowCountdown ? classes.time : classes.label;

  return (
    <div className={classes.container} data-test-id={dt.promotions.bonusCountdown}>
      <Text variant="title-small" className={classes.label}>
        {t('bonusModal.offerExpires')}
      </Text>
      <Text variant="title-small" className={timeClassName}>
        {displayText}
      </Text>
    </div>
  );
}
